import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';

import sessionReducer from './sessionSlice';
import cartoondrawReducer from './cartoondraw/cartoondrawReducer';
import mineCraftReducer from './mine_craft/mineCraftReducer';
import stickerMakerReducer from './sticker_maker/stickerMakerReducer';
import robloxReducer from './roblox/robloxReducer';
import modsFactoryReducer from './mods_factory/modsFactoryReducer';
import communityReducer from './community/communityReducer';
import sendgridReducer from "./sendgrid/sendgridReducer";
import callrecorderReducer from "./callrecorder/callrecorderReducer";
import watcherReducer from "./watcher/watcherReducer";
import ghMarketReducer from "./gh_market/ghMarketReducer";

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    cartoondraw: cartoondrawReducer,
    mineCraft: mineCraftReducer,
    stickerMaker: stickerMakerReducer,
    roblox: robloxReducer,
    modsFactory: modsFactoryReducer,
    community: communityReducer,
    sendgrid: sendgridReducer,
    callrecorder: callrecorderReducer,
    watcher: watcherReducer,
    ghMarket: ghMarketReducer,
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
